import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const authBaseEndpoint = ENDPOINTS.AUTH || "/auth/";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loginApi: builder.mutation({
      query: (credentials) => ({
        url: `${authBaseEndpoint}login`,
        method: METHODS.POST,
        body: credentials,
      }),
    }),

    // Register now only takes { email }
    registerApi: builder.mutation({
      query: (credentials) => ({
        url: `${authBaseEndpoint}register`,
        method: METHODS.POST,
        body: credentials,
      }),
    }),

    resetPasswordRequestApi: builder.mutation({
      query: (credentials) => ({
        url: `${authBaseEndpoint}reset`,
        method: METHODS.POST,
        body: credentials,
      }),
    }),

    resetPasswordApi: builder.mutation({
      query: (credentials) => ({
        url: `${authBaseEndpoint}reset-password`,
        method: METHODS.POST,
        body: credentials,
      }),
    }),

    verifyOtpApi: builder.mutation({
      query: (data) => ({
        url: `/otp-verifications/verify`,
        method: METHODS.POST,
        body: data,
      }),
    }),

    resendOtpApi: builder.mutation({
      query: (data) => ({
        url: `/otp-verifications/resend-otp`,
        method: METHODS.POST,
        body: data,
      }),
    }),

    // --- UPDATED GOOGLE LOGIN API ---
    googleLoginApi: builder.mutation({
      query: (tokenPayload) => ({
        url: `${authBaseEndpoint}google`, // Resolves to /auth/google
        method: METHODS.POST,
        body: tokenPayload, // Expects { id_token: "..." }
      }),
    }),

    changePasswordApi: builder.mutation({
      query: (credentials) => ({
        url: `${authBaseEndpoint}change-password`,
        method: METHODS.POST,
        body: credentials,
      }),
    }),

    logoutApi: builder.mutation({
      query: () => ({
        url: `${authBaseEndpoint}logout`,
        method: METHODS.POST,
      }),
    }),
  }),
});

export const {
  useLoginApiMutation,
  useRegisterApiMutation,
  useResetPasswordRequestApiMutation,
  useResetPasswordApiMutation,
  useVerifyOtpApiMutation,
  useResendOtpApiMutation,
  useChangePasswordApiMutation,
  useGoogleLoginApiMutation,
  useLogoutApiMutation,
} = authApiSlice;
